export default "__VITE_PUBLIC_ASSET__084db5ad__"